module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"pgh.events","short_name":"pgh.events","description":"pgh.events is a music-focused collection of events, videos, podcasts, playlists, articles and more in Pittsburgh, Pennsylvania.","start_url":"/","background_color":"#ffb300","theme_color":"#1a1a1b","display":"minimal-ui","icon":"src/images/icon-2026.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"90bc0bf755682b89d63620ce0a499135"},
    },{
      plugin: require('../plugins/source-plugin/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
